/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Target_LabelInputs */

const en_us2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight you want to reach (kg)`)
};

const pt_br2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que você quer alcançar (kg)`)
};

const es_419_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que quieres alcanzar (kg)`)
};

const pt_pt2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que queres alcançar (kg)`)
};

const fr_fr2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge à atteindre (kg)`)
};

const de_de2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgewicht (kg)`)
};

const it_it2_exercise_personal_goal_target_label = /** @type {(inputs: Exercise_Personal_Goal_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso che vuoi raggiungere (kg)`)
};

/**
* | output |
* | --- |
* | "Weight you want to reach (kg)" |
*
* @param {Exercise_Personal_Goal_Target_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_target_label = /** @type {((inputs?: Exercise_Personal_Goal_Target_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Target_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_target_label(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_target_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_target_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_target_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_target_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_target_label(inputs)
	return en_us2_exercise_personal_goal_target_label(inputs)
});
export { exercise_personal_goal_target_label as "exercise-personal.goal_target_label" }